import { useDocumentVisibility, useIntervalFn } from '@vueuse/core';
import dayjs from 'dayjs';
import { ref, computed, watch } from 'vue';

export function useClock(intervalSecond = 30) {
  const isPageVisible = useDocumentVisibility();

  const now = ref(dayjs());

  const clock = useIntervalFn(() => {
    now.value = dayjs();
  }, 1000 * intervalSecond); // 기본 30초

  const dateFormat = computed(() => {
    return {
      fullDate: now.value.format('YYYY년 M월 D일 dddd'),
      simpleDate: now.value.format('M월 D일 dddd'),
      hourMinute: now.value.format('A hh시 mm분'),
      month: now.value.format('M월'),
    };
  });

  watch(isPageVisible, (newValue, oldValue) => {
    if (newValue === 'visible' && oldValue === 'hidden') {
      clock.resume(); // 페이지 보임
    } else {
      clock.pause(); // 다른 탭, 창 최소화 등
    }
  });

  return {
    dateFormat,
    clock,
  };
}
